'use client'

import {ControlledForm, ControlledInputTextarea, ControlledRating} from "../../molecules/form";
import {useForm} from "react-hook-form";
import React from "react";
import {SButton, SLinkButton} from "../../atoms/button";
import {Account} from "@/lib/types";
import {Avatar} from "@/components/atoms/avatar";
import {useCreateCommentMutation} from "@/lib/client/slices";
import {useRouter} from "next/navigation";

export const CommentForm = ({objectId, objectType, account, withRating}: {
  objectId: string,
  objectType: string,
  account: Account | undefined,
  withRating?: boolean
}) => {
  const [comment, status] = useCreateCommentMutation()
  const router = useRouter();

  const form = useForm({
    defaultValues: {
      object_id: objectId,
      object_type: objectType,
      rating: undefined,
      content: '',
    }
  })

  if (!account) {
    return <div className="flex flex-col items-center justify-between py-4">
      <div>Connectez vous pour ajouter un commentaire</div>
      <div className="flex flex-row">
        <SLinkButton  href="/login">Connexion</SLinkButton>
        <SLinkButton  variant="highlight" href="/register">Créez mon compte gratuit</SLinkButton>
      </div>
    </div>
  }

  const handleSubmit = (data: any) => {
    comment(data).then(c => {
      form.reset()
      router.refresh()
    }).catch(console.error)
  }

  return <ControlledForm useForm={form} onSubmit={form.handleSubmit(handleSubmit)}>
    {withRating && <ControlledRating useForm={form} name="rating" max={5} min={1}/>}

    <div className="flex w-full items-center px-6  mt-4 border-t border-gray-200">
      <div className="flex-none">
        <Avatar src={account?.account_image_url} size="md"/>
      </div>
      <div className="w-full ">
        <ControlledInputTextarea useForm={form} name={"content"} rows={1} placeholder={"Ajoutez un commentaire..."}/>
      </div>
      <div><SButton type="submit">Envoyer</SButton></div>
    </div>
  </ControlledForm>
}